interface ListResponse {
  success: boolean
  message?: string
}

/**
 * Add to/remove from watch and favorite lists
 */
export class Lists {
  private selectors: NodeListOf<Element>

  constructor() {
    this.selectors = document.querySelectorAll('.js-watchlist, .js-favorites')

    if (this.selectors.length === 0) return

    this.bindEvents()
  }

  bindEvents(): void {
    this.selectors.forEach((selector) => {
      selector.addEventListener('click', async () => {
        const ajaxUrl = window.wp_data?.ajax_url
        const nonce = window.wp_data?.list_nonce
        const filmContainer = document.querySelector('#js-single-film') as HTMLElement
        const filmId = filmContainer?.dataset.filmId

        if (!ajaxUrl || !nonce || !filmId) {
          console.warn('Missing required data for list operation')
          return
        }

        let list: string | null = null

        if (selector.classList.contains('js-watchlist')) {
          list = 'watchlist'
        } else if (selector.classList.contains('js-favorites')) {
          list = 'favorites'
        }

        if (!list) return

        selector.classList.toggle('is-added')

        try {
          const formData = new FormData()
          formData.append('action', 'lists')
          formData.append('security', nonce)
          formData.append('list', list)
          formData.append('film_id', filmId)

          const response = await fetch(ajaxUrl, {
            method: 'POST',
            body: formData
          })

          const data: ListResponse = await response.json()
          
          if (!data.success) {
            console.error('List operation failed:', data.message)
          }
        } catch (error) {
          console.error('Error updating list:', error)
        }
      })
    })
  }
}
